<h3 class="font-bold text-lg">Tickets aktualisieren ({{ ticketIds()?.length }})</h3>
<fieldset class="bm-fieldset">
  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.status.enabled"
        (ngModelChange)="setControlEnabled(form.controls.status, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Status</span>
      <ng-select
        class="bm-join-item w-full"
        [items]="statusOptions()"
        bindLabel="name"
        bindValue="id"
        [formControl]="form.controls.status"
        [loading]="isLoading()"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center gap-1">
            @if (item.closed) {
              <span class="fa fa-check-circle text-success"></span>
            }
            @if (item.canceled) {
              <span class="fa fa-ban text-error"></span>
            }
            @if (item.report_closed) {
              <span class="fa fa-hand-paper-o text-muted"></span>
            }
            <span>{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.priority.enabled"
        (ngModelChange)="setControlEnabled(form.controls.priority, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Priorität</span>
      <ng-select
        class="w-full"
        [items]="priorityOptions()"
        bindLabel="name"
        bindValue="id"
        [formControl]="form.controls.priority"
        [loading]="isLoading()"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center gap-1">
            @if (item.color) {
              <span class="fa-stack" style="font-size: 60%">
                <i class="fa fa-circle fa-stack-2x" style="color: #333"></i>
                <i class="fa fa-circle fa-stack-2x" [style.color]="item.color"></i>
              </span>
            } @else {
              <span>&nbsp;</span>
            }
            <span>{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.technician.enabled"
        (ngModelChange)="setControlEnabled(form.controls.technician, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Techniker</span>
      <ng-select
        class="w-full"
        [items]="technicianOptions()"
        bindLabel="name"
        bindValue="id"
        [formControl]="form.controls.technician"
        [loading]="isLoading()"
        [multiple]="true"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center gap-1">
            <span>{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.description.enabled"
        (ngModelChange)="setControlEnabled(form.controls.description, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Fehlertext</span>
      <input class="bm-input w-full" [formControl]="form.controls.description" />
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.operationDescription.enabled"
        (ngModelChange)="setControlEnabled(form.controls.operationDescription, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Fehlertext Operation</span>
      <input class="bm-input w-full" [formControl]="form.controls.operationDescription" />
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.operationDate.enabled"
        (ngModelChange)="setControlEnabled(form.controls.operationDate, $event)"
      />
    </label>
    <label class="bm-floating-label w-full">
      <span class="bm-label">Einsatzdatum</span>
      <input
        class="w-full bm-input bm-join-item"
        [formControl]="form.controls.operationDate"
        [matDatepicker]="operationDatepicker"
        (click)="operationDatepicker.open()"
        (focus)="operationDatepicker.open()"
      />
      <mat-datepicker #operationDatepicker />
    </label>
    <label class="bm-floating-label w-full">
      <span class="bm-label">Uhrzeit</span>
      <input
        class="w-full bm-input bm-join-item"
        [formControl]="form.controls.operationDate"
        [matTimepicker]="operationTimepicker"
        (click)="operationTimepicker.open()"
      />
      <mat-timepicker #operationTimepicker (selected)="operationTimepicker.close()" />
    </label>
  </div>

  <div class="w-full bm-join">
    <label class="bm-join-item bm-btn bm-btn-square">
      <input
        type="checkbox"
        class="bm-checkbox"
        [ngModel]="form.controls.timeEstimation.enabled"
        (ngModelChange)="setControlEnabled(form.controls.timeEstimation, $event)"
      />
    </label>
    <label class="bm-join-item w-full bm-floating-label">
      <span class="bm-label">Kalkulierte Arbeitszeit</span>
      <input class="bm-input w-full" type="number" [min]="0" [formControl]="form.controls.timeEstimation" />
    </label>
  </div>

  @if (batchError()) {
    <div class="bm-alert bm-alert-error">
      <span class="fa fa-exclamation-triangle"></span>
      <span>{{ batchError() }}</span>
    </div>
  }
</fieldset>
<div class="flex flex-row items-center justify-end gap-2">
  <button class="bm-btn bm-btn-secondary" (click)="handleCancel()">Abbrechen</button>
  <button class="bm-btn bm-btn-primary" (click)="handleSave()" [disabled]="isSaving()">Speichern</button>
</div>
